function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  height: 100%;\n  z-index: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    transition: height 2.5s;\n    &::before {\n      content: \"\";\n      background-color: ", ";\n      height: ", "px;\n      width: ", "px;\n      border-radius: 50%;\n      position: absolute;\n      left: 0px;\n      top: -5px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    clip-path: polygon(0 0, 100% 0, 100% 70%, 55% 100%, 45% 100%, 0 70%);\n    height: ", "px;\n    overflow: hidden;\n    position: relative;\n    width: ", "px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
var DEFAULT_HEIGHT_PX = "120";
var DEFAULT_WIDTH_PX = "50";
var Wrapper = styled.div((_ref) => {
  var {
    height = DEFAULT_HEIGHT_PX,
    theme,
    width = DEFAULT_WIDTH_PX
  } = _ref;
  return css(_templateObject(), theme.colors.grey.grey50, height, width);
});
var Feed = styled.div((_ref2) => {
  var {
    theme,
    width = DEFAULT_WIDTH_PX
  } = _ref2;
  return css(_templateObject2(), theme.colors.black, theme.colors.grey.grey50, Math.round(parseInt(width) * 0.05) + 6, width);
});
var Border = styled.div(_templateObject3());

var Silo = props => {
  var {
    heightPct,
    shouldAnimate = true
  } = props;
  var [heightTimeout, setHeightTimeout] = useState(!shouldAnimate); // delay setting the beverage's height for the css transition to take effect

  useEffect(() => {
    if (shouldAnimate) {
      setTimeout(() => {
        setHeightTimeout(true);
      }, 0);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(Feed, _extends({
    style: {
      height: heightTimeout ? "".concat(heightPct, "%") : "100%"
    }
  }, props)), /*#__PURE__*/React.createElement(Border, null));
};

export default Silo;